import { useEffect } from 'react';
import { useProjectId } from 'owa-timestream-asset-sdk';
import { getProject } from 'owa-timestream-store';
import { logSpacesDatapoint } from 'owa-timestream-logging';

export function useLogOpenProject() {
    const projectId = useProjectId();
    useEffect(() => {
        logSpacesDatapoint('OUTLOOKSPACES_OPEN_PROJECT', {
            projectId,
            template_1: getProject(projectId).templateType,
        });
    }, [projectId]);
}
